module.exports = __webpack_public_path__ + "static/media/shengdiao019.9c545da2.jpg";